export const GET_MYEDITORSESSIONS_REQUEST = 'editorSessions/GET_MYEDITORSESSIONS_REQUEST';
export const GET_MYEDITORSESSIONS_SUCCESS = 'editorSessions/GET_MYEDITORSESSIONS_SUCCESS';
export const GET_MYEDITORSESSIONS_FAILURE = 'editorSessions/GET_MYEDITORSESSIONS_FAILURE';